{
  "comment": "M5 combat zones (M5 spec §8.3, §14.3; D-TBD: combat zones). Each faction day each contested system of a skirmishing or warring pair opens a zone with openChance, lasting durationS [min, max] s at a field or POI node; each side details shipsPerSide [min, max] patrol ships; off-screen it resolves as an M4 encounter, one round per roundS. The winner gains winInfluence there and winPressure against the loser. The HUD marks zones within hudRangeM. At most capacity zones at once. Starting values, tune freely.",
  "capacity": 64,
  "openChance": 0.5,
  "durationS": [1200, 2400],
  "shipsPerSide": [2, 4],
  "roundS": 60,
  "winInfluence": 10,
  "winPressure": 3,
  "hudRangeM": 30000
}
